import { render, staticRenderFns } from "./indexFragmingam.vue?vue&type=template&id=68c484a7&"
import script from "./indexFragmingam.vue?vue&type=script&lang=js&"
export * from "./indexFragmingam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports